import { useAppSelector } from 'hooks/reduxHooks'
import { APPLY_URL, EMPLOYEE_APPLY_URL } from 'loyalty/pages/loyaltyCreditCardPage/loyaltyCreditCardConstants'
import { isLEStaff } from 'selectors/accountSelectors'

/**
 * Single source of the application link for every apply CTA on the Société
 * Credit Card page, so employees are sent to their own form and everyone else
 * to the public one. Resolving to a single URL here keeps the other URL out of
 * the rendered markup entirely.
 */
export function useLoyaltyCreditCardApplyUrl(): string {
  const isStaff = useAppSelector(isLEStaff)

  return isStaff ? EMPLOYEE_APPLY_URL : APPLY_URL
}
